var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.classArgs,attrs:{"href":_vm.href,"target":_vm.item.target || '_self',"data-toggle":_vm.dataToggle}},[_c('span',{class:{ 'border-placeholder': _vm.border }},[_vm._v(_vm._s(_vm.item.display))])])
}
var staticRenderFns = []

export { render, staticRenderFns }